import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'lodash'
import goodsApi from '../../apis/goods-api'

Vue.use(Vuex)

const initialState = () => {
    return {
        'package_info' : {
            'application_rule' : [],
            'clause_composition' : [],
            'goods' : [],
            'goods_composition' : [],
            'goods_term_prices' : [],
            'package' : {},
            'resource_limit_groups' : [],
        },
        'package_goods' : [],
    }
}

const getters = {
    getChangeRule : state => {
        if(!state.package_info.application_rule[0]){
            return null
        }
        if(!state.package_info.application_rule[0].rule){
            return null
        }
        return state.package_info.application_rule[0].rule.change
    },
    getEssentialGoods : state => {
        return _.chain(state.package_info.application_rule)
            .flatMap(ruleInfo => {
                let essentialRuleList = ruleInfo.rule.goods.filter(goodsRuleInfo => {
                    if(goodsRuleInfo.rule.essential && goodsRuleInfo.rule.essential === 'Y'){
                        return true
                    }
                    return false
                });

                return essentialRuleList
            })
            .value()
    },
    getDefaultSelectGoodsList : state => {
        return _.chain(state.package_info.application_rule)
            .flatMap(ruleInfo => {
                let essentialRuleList = ruleInfo.rule.goods.filter(goodsRuleInfo => {
                    if(goodsRuleInfo.rule.default_select && goodsRuleInfo.rule.default_select === 'Y'){
                        return true
                    }
                    return false
                });

                return essentialRuleList
            })
            .value()
    },
    getPackageGoods : state => {
      return state.package_goods
    },
    searchPayTerms : state => {
        let findGoodsInfo = state.package_info.goods_term_prices.find(goodsTermPriceInfo => {
            return goodsTermPriceInfo.id === parseInt(state.package_info.package.main_goods_id)
        })
        if (!findGoodsInfo){
            return []
        }
        return findGoodsInfo.term_prices
    },
    getSupplyTerms : state => {
        return state.package_info.package.supply_terms
    },
    getDefaultPayTerm : (state, getters) => {
        if(!state.package_info.application_rule[0]){
            return getters.searchPayTerms[0].term_volume
        }
        if(!state.package_info.application_rule[0].rule.sales_term){
            return getters.searchPayTerms[0].term_volume
        }
        return state.package_info.application_rule[0].rule.sales_term.init
    },
    getDefaultTermUnit : state => {
        return state.package_info.package.supply_terms.term_unit
    },
    getPackageName : state => {
        return state.package_info.package.expose_name
    },
    getSubGoodsComposition : state => {
        let subGoodsComposition = []   // return할 subGoodsCompositionList
        let packageGoodsList = state.package_goods
        let goodsComposition = state.package_info.goods_composition

        // 현재 선택된 상품 리스트인 state.package_goods를 돌면서 goods_composition에서 상품들의 sub_goods를 찾아낸다.
        packageGoodsList.forEach((packageGoodsInfo) => {

            let findSubGoodsComposition = _.chain(goodsComposition)
                .filter(goodsCompositionInfo => parseInt(goodsCompositionInfo.goods_id) === parseInt(packageGoodsInfo.goods_id))
                .flatMap((goodsCompositionInfo) => {
                    /// 찾아낸 goods_composition 중에 sub_goods만 찾아서 추출
                    let matchedSubGoods = _.chain(goodsCompositionInfo.data)
                        .filter(goodsCompositionInfoData => goodsCompositionInfoData.area.name === "subgoods")
                        .flatMap(goodsCompositionInfoData => goodsCompositionInfoData)
                        .value()

                    return matchedSubGoods
                })
                .value()

            // 찾아낸 sub_goods_composition 정보들을 계속해서 병합
            subGoodsComposition = subGoodsComposition.concat(findSubGoodsComposition)
        })

        // sub_goods_composition의 sort 정보로 정렬 후 return
        subGoodsComposition.sort((prev, next) => {
            return parseInt(prev.sort) - parseInt(next.sort)
        })

        return subGoodsComposition
    },
    getSubGoodsInfoList : state => (mainGoodsId, subGoodsCompositionTypeId) => {
        let findGoodsInfo = state.package_info.goods.find(goodsInfo => {
            return goodsInfo.id === parseInt(mainGoodsId)
        })

        let findSubGoodsInfoList = _.chain(findGoodsInfo.sub_goods)
            .filter(subGoodsInfo => subGoodsCompositionTypeId.includes(subGoodsInfo.id))
            .flatMap((subGoodsInfo) => {
                // store 외부변경으로 인한 오류로 인하여 clone 후에 sorting하여 return
                let cloneSubGoodsInfo = _.clone(subGoodsInfo);
                cloneSubGoodsInfo.resources =
                    _.sortBy(cloneSubGoodsInfo.resources, 'sort')

                return cloneSubGoodsInfo
            })
            .value();
        return findSubGoodsInfoList
    },
    getDomainType : state => {
        let packageId = state['package_info']['package']['id']

        let applicationRule = state['package_info']['application_rule'].find((ruleInfo)=>{
            return parseInt(ruleInfo.package_id) === parseInt(packageId)
        });

        if(!applicationRule || !applicationRule.rule.domain_application){
            return "hiworks_office"
        }
        return applicationRule.rule.domain_application.type
    },
    getDomainDiscountRuleListForInstallationCost : state =>{
        let packageId = state['package_info']['package']['id']

        let applicationRule = state['package_info']['application_rule'].find((ruleInfo)=>{
            return parseInt(ruleInfo.package_id) === parseInt(packageId)
        })
        
        if(applicationRule && applicationRule.rule.domain_application){
            return applicationRule.rule.domain_application.discount_rule.installation_cost
        }
    },
    getMainGoodsId : state => {
        return parseInt(state.package_info.package.main_goods_id)
    }
}

const mutations = {
    setPackageInfo (state, packageInfo) {
        state['package_info'] = packageInfo
    },
    setPackageGoods (state, selectGoodsId) {
        let packageGoods = state.package_info.package.package_goods

        // 1. goods_group이 "없는" packageGoods info를 reMappedPackageGoods에 선별
        let reMappedPackageGoods = _.filter(packageGoods, packageGoodsInfo => {
            return packageGoodsInfo.goods_group.length <= 0
        })

        // 2. goods_group이 "있는" packageGoods info를 groupGoodsList에 선별
        let groupGoodsList = _.chain(packageGoods)
            .filter(goodsInfo => Object.keys(goodsInfo.goods_group).length > 0)
            .orderBy((goodsInfo) => parseInt(goodsInfo.goods_group.sort_order), ['asc'])
            .groupBy("goods_group.id")
            .flatMap(goodsInfo =>  goodsInfo)
            .value();
        
        // 3. 2번에서 추출한 goods_group이 있는 packageGoods가 존재했을때 
        if(groupGoodsList.length > 0){
            // 3.1 현재 선택되어있는 selectGoodsId가 있다면
            // selectGoodsId에 맞는 packageGoods의 groupInfo를 추출하여  reMappedPackageGoods에 push
            if(selectGoodsId){
                let findGroupGoodsInfo = groupGoodsList.find((groupGoodsInfo)=>{
                    return parseInt(groupGoodsInfo.goods_id) === parseInt(selectGoodsId)
                });

                reMappedPackageGoods.push({
                    goods_id: findGroupGoodsInfo['goods_id'],
                    expose_name: findGroupGoodsInfo['expose_name'],
                    sort_order: findGroupGoodsInfo['sort_order'],
                    goods_group: groupGoodsList
                })
            }
            // 3.2 현재 선택되어있는 selectGoodsId가 없다면
            // groupGoodsList중에 0번째 정보를 reMappedPackageGoods에 push
            else{
                reMappedPackageGoods.push({
                    goods_id: groupGoodsList[0]['goods_id'],
                    expose_name: groupGoodsList[0]['expose_name'],
                    sort_order: groupGoodsList[0]['sort_order'],
                    goods_group: groupGoodsList
                })
            }
        }

        // 4. 만들어진 reMappedPackageGoods를 sort_order순으로 정렬
        reMappedPackageGoods.sort((prev, next) => {
            return parseInt(prev['sort_order']) - parseInt(next['sort_order'])
        })

        // 5. 만들어진 reMappedPackageGoods에 goods_info와 goods_composition정보 주입
        reMappedPackageGoods.forEach((packageGoodsInfo, index) => {

            reMappedPackageGoods[index]['goods_info'] = state['package_info']['goods'].find(goodsInfo => {
                return goodsInfo.id === parseInt(packageGoodsInfo['goods_id'])
            });

            reMappedPackageGoods[index]['goods_composition'] = state['package_info']['goods_composition'].find(goodsCompositionInfo => {
                return goodsCompositionInfo.goods_id === parseInt(packageGoodsInfo['goods_id'])
            })['data'];
        })
        state['package_goods'] = reMappedPackageGoods
    },
}

const actions = {
    async loadPackageInfo ({commit}, {packageId}) {
        return new Promise((resolve) => {
            goodsApi.loadPackageInfo(packageId)
                .then((apiResponse) => {
                    let data = apiResponse.data.data;
                    commit('setPackageInfo', data)
                    resolve()
                })
        })
    },
    async setPackageGoods ({commit}, selectGoodsId) {
        return new Promise((resolve) => {
            commit('setPackageGoods', selectGoodsId)
            resolve()
        })
    },
}

export default {
    namespaced: true,
    state: initialState,
    mutations,
    actions,
    getters,
    strict: process.env.NODE_ENV !== 'production'
}